import { SET_APPLICATION_STEP, SET_OVERVIEW_STEP } from 'actions'
import cloneDeep from 'clone-deep'
import { BorrowerSeparatorList } from 'pages/LoanApplication/config'
import { borrowerMenuKey } from 'pages/LoanApplication/util'

import { createReducer } from '../utils'

export const mapStepDetailDescription: Record<string, string> = {
  rateAndPrice: 'Select Interest Rate and Base Price',
  lockRate: 'Lock Rate',
  dataComplete: 'Complete Application Data',
  signApplication: 'Sign Application',
  creditScorePull: 'Pull Credit Score',
  submitToAE: 'Submit Loan',
  conditionSubmit: 'Submit Conditions',
  submitSetup: 'Submit to LoanSetup',
  submitUnderwriter: 'Submit to Underwriter',
}

interface IOverviewStatus {
  label: string
  status: number
  detail: Record<string, number>
  errors?: any[]
}

export const stepInitialState = () => {
  const result: { application: Record<string, number>; overview: Record<string, IOverviewStatus> } = {
    application: {
      property: -1,
      mlds: -1,
    },
    overview: {
      structure: {
        label: 'Loan Structure',
        status: 0,
        detail: {
          rateAndPrice: 0,
          lockRate: -1,
        },
        errors: [],
      },
      application: {
        label: 'Loan Application',
        status: -1,
        detail: {
          dataComplete: 0,
          creditScorePull: 0,
          signApplication: 0,
        },
      },
      submit: {
        label: 'Loan Submission',
        status: -1,
        detail: {
          submitToAE: 0,
          submitSetup: 0,
          submitUnderwriter: 0,
          conditionSubmit: 0,
        },
      },
    },
  }

  BorrowerSeparatorList.forEach((borrowerSep) => {
    ;['borrower', 'asset', 'track', 'hmda', 'credit', 'sign', 'additionalMember'].forEach(
      (key) => (result.application[borrowerMenuKey(borrowerSep, key)] = -1),
    )
  })

  return result
}

export const step = createReducer(stepInitialState(), {
  [SET_OVERVIEW_STEP]: (state: any, payload: any) => {
    let newState = cloneDeep(state)
    newState.overview = payload.data
    return newState
  },
  [SET_APPLICATION_STEP]: (state: any, payload: any) => {
    let newState = cloneDeep(state)
    newState.application = payload.data
    return newState
  },
})
